var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36C0 16.1178 16.1178 0 36 0C55.8823 0 72 16.1178 72 36C72 55.8823 55.8823 72 36 72C16.1178 72 0 55.8823 0 36Z",
    fill: "#3A6AB6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2187_2172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3684 27.7634C39.3684 29.9001 41.1004 31.6322 43.2368 31.6322C43.8306 31.6322 44.3931 31.4984 44.8958 31.2593L44.8947 42.9603C44.8947 44.6391 43.5339 46 41.8553 46H28.0395C26.3608 46 25 44.6391 25 42.9603V29.1432C25 27.4644 26.3608 26.1035 28.0395 26.1035L39.7418 26.1031C39.5024 26.6062 39.3684 27.1692 39.3684 27.7634ZM43.2368 25C44.7629 25 46 26.2372 46 27.7634C46 29.2896 44.7629 30.5268 43.2368 30.5268C41.7108 30.5268 40.4737 29.2896 40.4737 27.7634C40.4737 26.2372 41.7108 25 43.2368 25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2187_2172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle1);
export default __webpack_public_path__ + "static/media/circle-1.9652facfdb6516e45d9c2f3ddd2c1614.svg";
export { ForwardRef as ReactComponent };